import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

export const videoCategoryListColumns = (
  deleteMutation,
  token,
  setLoading,
  selectCategory
) => {
  return [
    {
      title: i18n.t("video.category.name"),
      render: (item) => (
        <span>{i18n.getPropNameByLocale(item, "name")}</span>
      ),
    },
    {
      title: i18n.t("shows.sortTypesTitle"),
      dataIndex: "order",
      width: 100,
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 180,
    },
    {
      title: i18n.t("users.actions"),
      width: 200,
      render: (item) => (
        <>
          <Popconfirm
            title={i18n.t("sales.deleteWarning")}
            onConfirm={() => {
              setLoading(true);
              deleteMutation.mutate({
                resource: "video-category",
                params: {
                  id: item.id,
                  token,
                },
              });
            }}
            okText={i18n.t("base.modal.okText")}
            cancelText={i18n.t("base.modal.cancelText")}
          >
            <Button size="small" icon={<DeleteOutlined />}>
              {i18n.t("common.delete")}
            </Button>
          </Popconfirm>
          <Button
            onClick={() => selectCategory(item)}
            size="small"
            icon={<EditOutlined />}
            style={{ marginInlineStart: 8 }}
          >
            {i18n.t("product.productItem.actionEdit")}
          </Button>
        </>
      ),
    },
  ];
};
